import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function DiagnosisSection() {
  const problems = [{
    title: 'El No-Show es la hemorragia silenciosa de las clínicas.',
    body: 'Una cita cancelada sin aviso no es solo un paciente menos. Es el costo del staff, el espacio, el equipo y el tiempo del doctor que no se puede recuperar. Un sistema automatizado de recordatorios y depósito previo elimina este problema en menos de 30 días.'
  }, {
    title: 'Los pacientes buscan en Google, no en el directorio médico.',
    body: 'El 77% de los pacientes usan buscadores online antes de seleccionar un médico. Si no apareces en el Top 3 de Google Maps para tu especialidad, estás invisible para el 77% de tus pacientes potenciales.'
  }, {
    title: 'No tienes un sistema de pacientes recurrentes.',
    body: 'La base de datos de tus pacientes actuales es el activo más valioso de tu clínica. Sin un sistema de reactivación, estás pagando por pacientes nuevos cuando ya tienes cientos de pacientes que dejaron de venir y podrían regresar con un simple mensaje.'
  }];
  return <section className="py-20 md:py-24 px-5 sm:px-6 md:px-8 bg-[#0a0a0a]" data-id="element-119">
      <div className="max-w-4xl mx-auto" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-12 md:mb-16" data-id="element-121">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-4" data-id="element-122">
            El Diagnóstico
          </h2>
          <div className="w-20 h-1 bg-gold rounded-full" data-id="element-123"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="space-y-6 md:space-y-8" data-id="element-124">
          {problems.map((problem, index) => <motion.div key={index} variants={cardVariants} className="bg-carbon border-l-4 border-gold p-6 md:p-8 rounded-r-lg shadow-2xl relative overflow-hidden group" data-id="element-125">
              <div className="absolute top-0 right-0 text-8xl md:text-9xl font-black text-white/[0.02] -mt-6 md:-mt-8 -mr-4 select-none pointer-events-none transition-transform duration-500 group-hover:scale-110" data-id="element-126">
                0{index + 1}
              </div>
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-3 md:mb-4 relative z-10" data-id="element-127">
                {problem.title}
              </h3>
              <p className="text-gray-400 text-sm sm:text-base md:text-lg leading-relaxed relative z-10" data-id="element-128">
                {problem.body}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}